import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  name: 'EXTRACT',
  category: FunctionCategory.LOOKUP,
  description: 'Extracts element from each list in a column.',
  shortDescription: 'Extracts element from list',
  params: [
    {
      name: 'value',
      type: ArgType.any,
      description: 'A column of lists to extract from.',
    },
    {
      name: 'index',
      type: ArgType.number,
      description: 'Either a column or number, index of the element to extract.',
    },
  ],
} satisfies AnalysisFunction;
